<template>
  <div id="goodsDetail" v-if="returndata">
    <!-- 返回按钮 -->
    <div class="box" ref="isShow">
      <div class="back">
        <span class="title">{{goodsMsg.goods_name}}</span>
        <span class="closeImg">
          <img src=".././assets/img/箭头 (3).png" @click="goback" class="backImg" />
        </span>
      </div>
    </div>
    <!-- 商品展示轮播图 -->
    <div class="show">
      <van-swipe :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item,i) in linkImgList" :key="i">
          <img :src=" lbflag?item.image_url:'http://youwei.jingmaie-co.cn/'+item.image_url" class="showImg" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <!-- 商品说明 -->
    <div class="Explain">
      <div class="name">{{goodsMsg.goods_name}}</div>
      <!-- 商品价格/销量 -->
      <div class="price">
        <span class="title">价格</span>
        <span class="nowPrice">￥{{goodsMsg.shop_price}}</span>
        <span class="oldPrice">￥{{goodsMsg.market_price}}</span>
        <span class="sellNum">销量{{goodsMsg.sales_sum+goodsMsg.virtual_sales_sum}}笔</span>
      </div>
    </div>
    <!-- 商品规格 -->
    <div class="type">
      <span>规格</span>
      <span class="spec_goods_price">{{spec_goods_price==''?'暂无规格':spec_goods_price}}</span>
    </div>
    <!-- 商品信息 -->
    <div class="message">
      <div>参数</div>
      <span class="description">{{goodsMsg.description}}</span>
    </div>
    <!-- 图文详情 -->
    <div>
      <div class="text">
        <i class="line1"></i>
        <span>图文详情</span>
        <i class="line2"></i>
      </div>
      <div v-for="item in mobile_content" :key="item.id">
        <img
          :src="mcflag?item.value:'http://youwei.jingmaie-co.cn/'+item.value"
          class="mobile_content"
        />
      </div>
    </div>
    <!-- 底部立即购买按钮 -->
    <div class="footer" @click="showPopup">立即购买</div>
    <!-- 弹出选择框 -->
    <div class="popupBackground" v-if="show" @click.stop="closepopup">
      <div class="popup" @click.stop="pop">
        <div class="p-top">
          <img class="p-img" :src="popimg" />
          <span class="p-center">
            <span>￥{{specprice}}</span>
            <p>库存{{speccount}}件</p>
          </span>
        </div>
        <!-- 购买数量 -->
        <div class="p-buy">
          <span class="p-text">购买数量</span>
          <span class="p-num">
            <span class="sub" @click="subNum">-</span>
            <input type="text" v-model="valueNum" class="num-val" />
            <span class="add" @click="addNum">+</span>
          </span>
        </div>
        <div class="line"></div>
        <!-- 商品规格 -->
        <div class="specs" v-for="(spec,n) in psSpecValueList" :key="n">
          <div class="specs-name">{{spec.spec_name}}</div>
          <span
            v-for="(specfo,index) in spec.spec_list"
            :key="index"
            class="specs-value"
            @click="Selection(specfo,n,$event,index)"
            :class="[specfo.isShow?'selected':'sclecteds',subIndex[n]==index?'selected':'selecteds']"
          >{{specfo.item}}</span>
        </div>
        <!-- 确定购买按钮 -->
        <div class="footer" @click.stop="goOrder">确定</div>
      </div>
    </div>
  </div>
</template>
<script>
import qs from "qs";
import { goodsDetail } from "@/api";
export default {
  data() {
    return {
      returndata: false,
      token: "",
      goodsMsg: "", //商品详细信息
      description: "", //商品信息
      linkImgList: [], //轮播图
      spec_goods_price: "", //商品规格
      psSpecValueList: "", //商品规格值
      specprice: "", //规格价格
      speccount: "", //规格库存
      itemid: "", //规格id
      specpriceList: "", //规格组合列表
      popimg: "", // 选择商品规格图片
      consignee: "", // 用户默认收获地址
      psSku: "", //ps快照
      specValueIds: 0, //被选中商品id
      readySelect: "", //被选中商品的样式
      addAddress: false, //是否显示添加地址页面
      mobile_content: "", //富文本
      mcflag: false,
      lbflag:false,
      valueNum: 0, //购买数量
      show: false, //是否显示弹出框
      agree: false, //是否勾选用户协议
      showAgreement: false, //是否现实用户条款
      windowTop: 0,
      selectArr: [], //存放被选中的值
      subIndex: [], //是否选中 因为不确定是多规格还是单规格，所以这里定义数组来判断
      selectId: [], //存放选中规格的id
      selectInfo: [], //选中商品规格具体信息
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    //弹出立即购买
    showPopup() {
      this.show = true;
      if (window.localStorage.getItem("token") == null) {
        this.$router.push({ name: "login" });
      } else {
        this.token = window.localStorage.getItem("token");
      }
    },
    // 关闭弹出选项
    closepopup() {
      this.show = false;
    },
    pop() {},
    // 打开用户协议
    openAgreement() {
      this.showAgreement = true;
    },
    // 关闭用户协议
    closeAgreement() {
      this.showAgreement = false;
    },
    // 商品数量
    subNum() {
      if (this.valueNum <= 0) {
        this.valueNum = 0;
      } else {
        this.valueNum--;
      }
    },
    addNum() {
      if (this.valueNum >= this.speccount) {
        this.valueNum = this.speccount;
        this.$toast("库存不足");
      } else {
        this.valueNum++;
      }
    },
    // 关闭下载app窗口
    close(e) {
      e.currentTarget.parentElement.style.display = "none";
    },
    // 关闭地址窗口
    closeAddress() {
      this.addAddress = false;
    },
    // 获取商品详情
    async getDetail() {
      let params = {
        id: this.$route.params.id,
      };
      let res = await goodsDetail(qs.stringify(params));
      if (res.status === 1) {
        this.returndata = true;
        // 轮播图列表
        this.linkImgList = res.result.gallery;
        for(var i=0;i<this.linkImgList.length;i++){
          if(this.linkImgList[i].image_url.indexOf('http')!=-1){
            this.lbflag=true
          }else{
            this.lbflag=false
          }
        }
        // 选择规格图品
        this.popimg = this.linkImgList[0].image_url;
        // 商品详细信息
        this.goodsMsg = res.result.goods;
        // 富文本
        this.mobile_content = this.goodsMsg.mobile_content;
        for (var i = 0; i < this.mobile_content.length; i++) {
          if (this.mobile_content[i].value.indexOf("http") != -1) {
            this.mcflag = true;
          } else {
            this.mcflag = false;
          }
        }
        // 用户默认地址
        this.consignee = res.result.consignee;
        // 商品规格名
        this.spec_goods_price = res.result.goods_spec_list[0].spec_name;
        // 商品规格值
        this.psSpecValueList = res.result.goods_spec_list;
        // 商品规格组合
        this.specpriceList = res.result.spec_goods_price;
        // 默认价格
        this.specprice = this.goodsMsg.market_price;
        // 默认库存
        this.speccount = this.goodsMsg.store_count;
      } else {
        this.$toast(res.msg);
      }
    },
    //返回按钮
    goback() {
      this.$router.push("/index");
    },
    // 点击立即购买提交订单
    goOrder() {
      if (this.valueNum === 0) {
        this.$toast("请选择商品数量");
      } else if (this.itemid == "") {
        this.$toast("请选择商品规格");
      } else if (this.valueNum > this.speccount) {
        this.$toast("商品库存不足");
      } else if (this.valueNum != 0 && this.itemid != "") {
        let params = {
          goods_id: this.goodsMsg.goods_id, //商品id
          goods_num: this.valueNum, //商品数量
          item_id: this.itemid, //商品规格id
          address_id: this.consignee.address_id, //用户默认地址
          token: this.token,
        };
        this.$router.push({
          name: "orderPage",
          query: { orderData: JSON.stringify(params) },
        });
      }
    },
    // 选择商品规格
    Selection(item, n, event, index) {
      this.selectId = [];
      let that = this;
      if (that.selectArr[n] != item) {
        that.selectArr[n] = item;
        that.subIndex[n] = index;
      } else {
        that.selectArr[n] = "";
        that.subIndex[n] = -1; //去掉选中的颜色
      }
      that.check_Item(that.subIndex);
      for (var i = 0; i < this.selectArr.length; i++) {
        if (
          this.selectArr[i] == "" ||
          this.selectArr[i] == null ||
          typeof this.selectArr[i] == undefined
        ) {
          this.selectArr.splice(i, 1);
          i = i - 1;
        }
      }
      for (let i = 0; i < this.selectArr.length; i++) {
        this.selectId.push(this.selectArr[i].item_id);
      }
      this.selectId.sort(function (a, b) {
        return a - b;
      });
      this.selectId = this.selectId.join("_");
      this.selectInfo = this.specpriceList.find((value) => {
        return value.key === this.selectId;
      });
      // 如果规格都选择了，就根据规格给价格和库存重新赋值
      if (this.psSpecValueList.length === this.selectArr.length) {
        this.specprice = this.selectInfo.price;
        this.speccount = this.selectInfo.store_count;
        this.itemid = this.selectInfo.item_id;
      } else {
        // 默认价格
        this.specprice = this.goodsMsg.market_price;
        // 默认库存
        this.speccount = this.goodsMsg.store_count;
      }
    },
    // 检查选中的每一项
    check_Item(n) {
      let that = this;
      let option_s = that.psSpecValueList;
      let result_s = []; //定义数组存储被选中的值
      for (let i in option_s) {
        result_s[i] = that.selectArr[i]
          ? that.selectArr[i]
          : option_s[i].spec_list[0];
      }
      for (let i in option_s) {
        let last = result_s[i]; //把选中的值存放到字符串last去
        for (let k in option_s[i].spec_list) {
          result_s[i] = option_s[i].spec_list[k]; //赋值，存在直接覆盖，不存在往里面添加name值
          option_s[i].spec_list[k].isShow = that.is_May(result_s);
          result_s[i].spec_name = option_s[i].spec_name;
        }
        result_s[i] = last; //还原，目的是记录点下去那个值，避免下一次执行循环时避免被覆盖
      }
      that.$forceUpdate(); //重绘
    },
    // 对比数组中的结果
    is_May(result_s) {
      for (let i in result_s) {
        if (result_s[i] == "") {
          return true; //如果数组里有为空的值，那直接返回true
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
#goodsDetail {
  width: 750px;
  padding: 80px 0;
  position: relative;
  z-index: 999;
  background-color: #f6f6f6;
  .box {
    width: 750px;
    height: 80px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    box-sizing: border-box;
    opacity: 1;
    .back {
      width: 750px;
      height: 80px;
      font-size: 28px;
      color: #000000;
      background-color: #f6f6f6;
      box-sizing: border-box;
      text-align: center;
      padding-top: 20px;
      .title {
        display: block;
        width: 600px;
        height: 50px;
        overflow: hidden;
        margin: 0 auto;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .closeImg {
        display: inline-block;
        width: 15px;
        height: 27px;
        position: absolute;
        left: 30px;
        top: 30px;
        .backImg {
          width: 15px;
          height: 27px;
        }
      }
      .goods {
        position: absolute;
        top: 30px;
        left: 190px;
        // border-bottom: 1px solid #FF544F;
        padding-bottom: 20px;
        box-sizing: border-box;
        a {
          color: #000000;
        }
      }
      .comment {
        position: absolute;
        top: 30px;
        left: 332px;
        padding-bottom: 20px;
        box-sizing: border-box;
        a {
          color: #000000;
        }
      }
      .detail {
        position: absolute;
        top: 30px;
        right: 243px;
        padding-bottom: 20px;
        box-sizing: border-box;
        a {
          color: #000000;
        }
      }
      .share {
        display: inline-block;
        width: 33px;
        height: 32px;
        position: absolute;
        top: 26px;
        right: 98px;
        .shareImg {
          width: 32px;
          height: 32px;
        }
      }
      .more {
        display: inline-table;
        width: 42px;
        height: 8px;
        position: absolute;
        top: 20px;
        right: 29px;
        .moreImg {
          width: 42px;
          height: 8px;
        }
      }
    }
  }

  .show {
    height: 750px;
    width: 750px;
    // margin: 8px 0;
    .van-swipe {
      width: 750px;
      height: 750px;
      z-index: -1;
      .van-swipe-item {
        width: 750px;
        height: 750px;
        .showImg {
          width: 750px;
          height: 750px;
        }
      }
    }
  }

  .Explain {
    padding: 20px 30px;
    background-color: #fff;
    position: relative;
    z-index: -1;

    .name {
      width: 624px;
      font-size: 36px;
      color: #4a4a4a;
    }
    .price {
      position: relative;
      .title {
        font-size: 24px;
        color: #4a4a4a;
      }
      .nowPrice {
        margin-left: 10px;
        font-size: 40px;
        color: #ff544f;
      }
      .oldPrice {
        margin-left: 10px;
        font-size: 20px;
        color: #7a797a;
        text-decoration: line-through;
      }
      .sellNum {
        font-size: 24px;
        color: #7a797a;
        position: absolute;
        bottom: 0;
        right: 0;
      }
    }
  }
  .type {
    background-color: #fff;
    padding: 21px 0 30px 19px;
    margin: 10px 0;
    font-size: 24px;
    color: #7a797a;
    .spec_goods_price {
      margin-left: 20px;
      color: #000;
    }
  }
  .message {
    background-color: #fff;
    padding: 21px 0 30px 19px;
    margin: 10px 0;
    font-size: 24px;
    color: #7a797a;
    .msg {
      margin: 10px 5px;
    }
  }

  .text {
    margin: 19px 29px;
    .line1 {
      display: inline-block;
      width: 270px;
      height: 1px;
      background-color: #7a797a;
    }
    span {
      font-size: 20px;
      color: #7a797a;
      margin: 0 24px;
    }
    .line2 {
      display: inline-block;
      width: 270px;
      height: 1px;
      background-color: #7a797a;
    }
  }
  .mobile_content {
    width: 750px;
  }
  .footer {
    width: 750px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    position: fixed;
    left: 0;
    bottom: 0;
    font-size: 28px;
    color: #ffffff;
    background-color: #ff544f;
  }
  .popupBackground {
    width: 750px;
    height: 100%;
    z-index: 9999;
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.6);
    .popup {
      width: 750px;
      height: 70%;
      background-color: #fff;
      padding: 24px 28px 0 26px;
      position: fixed;
      bottom: 0;
      left: 0;
      box-sizing: border-box;
      .line {
        height: 1px;
        width: 696px;
        background-color: #c2c2c2;
      }
      .p-top {
        .p-img {
          display: inline-block;
          width: 220px;
          height: 220px;
        }
        .p-center {
          margin-left: 30px;
          display: inline-block;
          height: 80px;
          span {
            color: #ff544f;
            font-size: 40px;
          }
          p {
            margin: 0;
            font-size: 24px;
            color: #7a797a;
          }
        }
      }
      .p-buy {
        display: flex;
        margin: 42px 0 35px 0;
        justify-content: space-between;
        .p-text {
          display: inline-block;
          font-size: 28px;
          color: #000000;
        }
        .p-num {
          font-size: 24px;
          color: #000000;
          display: inline-block;
          height: 40px;
          overflow: hidden;
          .sub,
          .add {
            display: inline-block;
            width: 60px;
            height: 40px;
            line-height: 40px;
            color: #c2c2c2;
            font-size: 32px;
            text-align: center;
            background-color: #f5f5f5;
          }
          .num-val {
            display: inline-block;
            width: 80px;
            height: 40px;
            font-size: 28px;
            padding: 0;
            line-height: 40px;
            margin: 0 3px;
            text-align: center;
            color: #6d6d6d;
            background-color: #f5f5f5;
            border: none;
            outline: none;
            -webkit-appearance: none;
          }
        }
      }
      .specs {
        font-size: 28px;
        color: #000000;
        .specs-name {
          height: 60px;
          line-height: 60px;
          font-size: 28px;
          color: #000;
          margin-bottom: 10px;
        }
        .specs-value {
          display: inline-block;
          background-color: #f5f5f5;
          font-size: 24px;
          color: #7a797a;
          margin-right: 10px;
          padding: 14px 34px;
          border-radius: 10px;
        }
        .selected {
          background-color: #ff544f;
          color: #f5f5f5;
        }
        .selecteds {
          background-color: #f5f5f5;
          color: #686868;
        }
      }

      .addAddress {
        width: 750px;
        height: 876px;
        position: fixed;
        bottom: 0;
        left: 0;
        background-color: #f6f6f6;
        z-index: 1;
        box-sizing: border-box;
        .addAddress-title {
          width: 100%;
          height: 80px;
          line-height: 80px;
          text-align: center;
          background-color: #fff;
          img {
            width: 15px;
            height: 27px;
            position: absolute;
            top: 30px;
            left: 30px;
          }
        }
        .userInfo {
          padding: 20px;
          width: 750px;
          height: 220px;
          box-sizing: border-box;
          background-color: #fff;
          margin: 10px 0;
          .username,
          .usernum {
            width: 100%;
            height: 100px;
            line-height: 60px;
            border-bottom: 1px solid #f6f6f6;
            font-size: 16px;
            padding-left: 10px;
            box-sizing: border-box;
            input {
              width: 400px;
              border: none;
              margin-left: 20px;
              outline: none;
              -webkit-appearance: none;
              font-size: 16px;
              height: 70px;
              line-height: 70px;
              background-color: #fff;
            }
          }
          .usernum {
            border-bottom: none;
          }
        }

        .userPro,
        .userCit,
        .userAre {
          height: 60px;
          padding: 10px;
          background-color: #fff;
          border-bottom: 1px solid #f6f6f6;
          font-size: 16px;
          span {
            font-size: 16px;
            color: #000;
            line-height: 40px;
            margin-left: 20px;
            margin-right: 20px;
          }
          select {
            width: 80%;
            height: 100%;
            border: none;
            border: 1px solid #f6f6f6;
            outline: none;
            appearance: none;
            -moz-appearance: none;
            -webkit-appearance: none;
            background: #fff;
            padding: 0 24px;
            font-size: 16px;
            option {
              border: 1px solid #f6f6f6;
              font-size: 16px;
            }
          }
        }
      }
    }
  }
}
</style>